import jQuery from "jquery";
window.$ = window.jQuery = jQuery;
import Swiper, { Navigation, Pagination, Scrollbar, Lazy } from 'swiper';



$(document).ready(function(){
	

	/* const swiper = new Swiper('.swiper', {

		modules: [Navigation, Pagination, Lazy],

		spaceBetween: 15,
		slidesPerView:1,
		grabCursor:true,
		mousewheel: true,		
		preloadImages: false,
		lazy: true,
		breakpoints: {
		  768: {
			slidesPerView: 1.1,
		  },
		  1024: {
			slidesPerView: 2.1,
		  }
		},

		pagination: {
		  el: '.swiper .swiper-pagination',
          type: "progressbar",
		  draggable: true,
		},	  

		navigation: {
		  nextEl: '.swiper .swiper-button-next',
		  prevEl: '.swiper .swiper-button-prev',
		},

	  }); */
	  

	  const swiper = new Swiper('.galleryswiper', {

		modules: [Navigation, Pagination, Scrollbar, Lazy],

		spaceBetween: 15,
		slidesPerView:1,
		grabCursor:true,
		mousewheel: true,		
		preloadImages: false,
		lazy: true,
		breakpoints: {
		  1024: {
			slidesPerView: 2,
		  }
		},

        scrollbar: {
          el: ".galleryswiper .swiper-scrollbar",
		  draggable: true,
        },

		pagination: {
		  el: '.galleryswiper .swiper-pagination',
		},	  

		navigation: {
		  nextEl: '.galleryswiper .swiper-button-next',
		  prevEl: '.galleryswiper .swiper-button-prev',
		},

	  });

		
});










